const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRfidCardsGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.397 -.298) scale(.2268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.184 40.862a2.957 2.957 0 0 0 5.914 0c0-8.814-7.145-15.958-15.958-15.958a2.956 2.956 0 0 0-2.956 2.957 2.956 2.956 0 0 0 2.956 2.957c5.548-.001 10.044 4.496 10.044 10.044ZM59.14 1.25a2.956 2.956 0 0 0-2.956 2.957 2.956 2.956 0 0 0 2.956 2.957c18.61 0 33.698 15.086 33.698 33.698a2.956 2.956 0 1 0 5.914 0c0-21.877-17.736-39.612-39.612-39.612Z",
    style: {
      fill: "#727272",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.862 53.33a2.957 2.957 0 0 0-2.957 2.958v24.356c0 6.531-5.295 11.826-11.827 11.826H19.491c-6.532 0-11.827-5.295-11.827-11.826V35.057c0-6.532 5.295-11.827 11.827-11.827h24.176a2.957 2.957 0 0 0 0-5.915H19.491c-9.797 0-17.74 7.943-17.74 17.741v45.587c0 9.798 7.943 17.74 17.74 17.74h45.587c9.798 0 17.741-7.942 17.741-17.74V56.287a2.958 2.958 0 0 0-2.957-2.957Z",
    style: {
      fill: "#727272",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.14,
    cy: 40.862,
    r: 4.131,
    style: {
      fill: "#727272"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.14 13.077a2.956 2.956 0 0 0-2.956 2.957 2.956 2.956 0 0 0 2.956 2.957c12.079 0 21.871 9.792 21.871 21.872a2.957 2.957 0 0 0 5.914 0c0-15.346-12.441-27.786-27.785-27.786ZM32.099 51.648v12.404a3.989 3.989 0 0 0 3.983 3.984h12.405a3.99 3.99 0 0 0 3.984-3.984v-3.245h13.634v5.758L51 81.67H18.464V34.031h25.204a2.957 2.957 0 0 0 0-5.914H18.464a5.913 5.913 0 0 0-5.913 5.914V81.67a5.913 5.913 0 0 0 5.913 5.914H51c1.729 0 2.958-.509 4.181-1.731l15.105-15.106c1.224-1.223 1.732-2.451 1.732-4.181v-5.758a5.914 5.914 0 0 0-5.914-5.914H52.47v-3.245a3.989 3.989 0 0 0-3.984-3.983H36.082a3.986 3.986 0 0 0-3.983 3.982Z",
    style: {
      fill: "#727272",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfidCardsGrey);
export default __webpack_public_path__ + "static/media/rfid-cards-grey.bdd35be69a75e0ea69e22492da153852.svg";
export { ForwardRef as ReactComponent };